<template>
  <div>
    <main>
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 700px">
          <div class="DispDateArea">
            <div style="">{{ dispDate }} ({{ dispDayOfWeek }}) {{ dispDateType }}</div>
          </div>
          <!-- シフト -->
          <div class="WorkM_Card">
            <div class="WorkM_Card_AreaHeader">
              <div class="d-flex justify-content-between">
                <div>本日の実績</div>
                <div class="mr-1" style="font-size: 0.8rem">
                  ( シフト {{ shiftStart }} - {{ shiftEnd }} )
                </div>
              </div>
            </div>
            <div class="WorkM_Card_ContentArea">
              <div v-for="workInfoItem in todayWorkInfo" :key="workInfoItem.detailNo">
                <div class="WorkInfoItem my-2" :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'text-danger' : ''">
                  <!-- 時間 -->
                  <div
                    class="WorkInfoItem_WorkTimeArea"
                    :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkInfoItem_WorkTimeArea_Red' : ''"
                    style="justify-content:center"
                  >
                    <div>{{ workInfoItem.startTime }}</div>
                    <div>{{ workInfoItem.endTime }}</div>
                  </div>
                  <!-- 内容 -->
                  <div class="WorkInfoItem_WorkContentArea">
                    <div class="WorkContent_ItemTypeArea">
                      <div
                        v-if="!isAttendanceCheck(workInfoItem.workSegment)"
                        class="WorkContent_ItemTypeArea_TypeLabel"
                        :class="!isAttendanceCheck(workInfoItem.workSegment) ? 'WorkContent_ItemTypeArea_TypeLabel_Red' : ''"
                      >
                        {{ getDispSegment(workInfoItem.workSegment) }}
                      </div>
                    </div>
                    <div class="mt-1">
                      <div>
                        <div v-if="workInfoItem.constructionCode !== '0'" class="WorkContent_ConstructionCode">[{{ workInfoItem.constructionCode }}]</div>
                        <div class="WorkContent_ConstructionName">{{ workInfoItem.constructionName }}</div>
                      </div>
                      <div class="WorkContent_ConstructionName">
                        <div class="WorkList_DispMemoArea" v-html="setLineFeedCode(workInfoItem.itemNote)"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 text-center font-weight-bold pt-1 pb-1">
                <div v-if="dailyreportBacklogFlg" class="text-danger" style="font-size: 0.9rem" @click="clickLinkButton('/WorkCalendar')" >未提出の勤怠報告があります</div>
                <div v-if="applicationRequestApprovalFlg" class="text-danger" style="font-size: 0.9rem" @click="clickLinkButton('/Approval')" >承認待ちの申請・報告があります</div>
                <div v-if="dailyreportConfirmedFlg" class="text-danger" style="font-size: 0.9rem" @click="clickLinkButton('/WorkCalendar')" >未確定の勤怠報告があります</div>
              </div>
            </div>
          </div>
          <div class="WorkM_Card WorkM_Card__MonthSummary mt-4">
            <div class="WorkM_Card_AreaHeader WorkM_Card_AreaHeader__MonthSummary">
              <div>今月の出退勤</div>
            </div>
            <div class="WorkM_Card_ContentArea">
              <div class="SummaryItem">
                <div class="SummaryItem_Header">出勤</div>
                <div class="SummaryItem_Content">
                  <div>{{ workingDays }}日</div>
                </div>
              </div>
              <div class="SummaryItem">
                <div class="SummaryItem_Header">残業・休日</div>
                <div class="SummaryItem_Content">
                  <div>
                    {{overtimeHolidayTime}}
                  </div>
                  <div>( 内災害 {{ disasterTime }} )</div>
                </div>
              </div>
              <!-- warningOvertimeType 0：ナシ、1：ピンク、2：赤 -->
              <div v-if="overtimeDisplayFlg" class="SummaryItem">
                <div class="SummaryItem_Header">残業</div>
                <div class="SummaryItem_Content">
                  <table>
                    <tr v-bind:class="{'text-overtime-warning': warningOvertimeType === 1, 'text-danger': warningOvertimeType === 2, 'font-weight-bold': warningOvertimeType !== 0 }">
                      <td class="pl-1">月間</td>
                      <td v-if="overtimeWorkTime != null" class="pl-1">{{ overtimeWorkTime }}</td>
                      <td v-if="overtimeMonthlyMaxTime != null" class="pl-1">( {{ overtimeMonthlyMaxTime }} )</td>
                    </tr>
                    <tr v-bind:class="{'text-overtime-warning': warningYealyOvertimeType === 1, 'text-danger': warningYealyOvertimeType === 2, 'font-weight-bold': warningYealyOvertimeType !== 0 }">
                      <td class="pl-1">年間</td>
                      <td v-if="yealyOvertimeWorkTime != null" class="pl-1">{{ yealyOvertimeWorkTime }}</td>
                      <td v-if="overtimeYealyMaxTime != null" class="pl-1">( {{ overtimeYealyMaxTime }} )</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div v-if="remainPaidLeaveDisplayFlg">
                <div class="SummaryItem">
                  <div class="SummaryItem_Header">有休</div>
                  <div class="SummaryItem_Content">
                    <div v-bind:class="{'text-danger': warningYearPaidLeaveFlg == true}" v-if="paidLeaveDays !== null && paidLeaveYealyDays !== null">
                      {{ paidLeaveDays.toFixed(1) }}日 ( {{ paidLeaveYealyDays.toFixed(1) }}日 )
                    </div>
                    <div v-if="remainPaidLeave !== null">
                      ( 残数 {{ remainPaidLeave.toFixed(1) }}日 )
                    </div>
                  </div>
                </div>
                <div class="SummaryItem">
                  <div class="SummaryItem_Header">時間有休</div>
                  <div class="SummaryItem_Content">
                    <div v-bind:class="{'text-danger': warningTimePaidLeaveFlg == true}" v-if="paidHolidaysTime !== null && maxPaidHolidaysTime !== null">
                      {{ paidHolidaysTime }} ( {{ maxPaidHolidaysTime }} )
                    </div>
                  </div>
                </div>
                <div class="SummaryItem">
                  <div class="SummaryItem_Header">法定取得</div>
                  <div class="SummaryItem_Content">
                    <div v-if="countPaidHolidaysOverHalfTime !== null && maxCountPaidHolidaysOverHalfTime !== null">
                      {{ countPaidHolidaysOverHalfTime }}回 ( {{ maxCountPaidHolidaysOverHalfTime }}回 )
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>

<script>
import config from "../const/config";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      shiftStart: null,
      shiftEnd: null,
      systemVersion: null,
      dispDate: null,
      dispDayOfWeek: null,
      todayWorkInfo: [],
      dispDateType: null,
      dailyreportBacklogFlg: null,
      applicationRequestApprovalFlg: null,

      workingDays: 0,
      workingTime: null,
      overtimeHolidayTime: null,
      disasterTime: null,
      paidLeaveDays: 0,                     // 年間取得日数
      paidLeaveTime: null,
      absenceDays: 0,
      absenceTime: null,
      lateArrivalEarlyDepartureTime: null,
      specialVacationDays: 0,
      specialVacationTime: null,
      remainPaidLeaveDisplayFlg: false,     // 有休管理区分フラグ
      dailyreportConfirmedFlg: false,
      remainPaidLeave: 0,                   // 有休残数
      paidLeaveYealyDays: 0,                // 年間付与日数
      overtimeDisplayFlg: false,
      warningOvertimeType: 0,
      overtimeWorkTime: null,
      overtimeMonthlyMaxHours: 0,
      overtimeMonthlyMaxTime: 0,            // 月間MAX残業時間(HH:MM)
      warningYealyOvertimeType: 0,
      yealyOvertimeWorkTime: null,
      overtimeYealyMaxHours: 0,
      overtimeYealyMaxTime: 0,              // 年間MAX残業時間(HH:MM)
      paidHolidaysTime: 0,                  // 時間有休取得数
      maxPaidHolidaysTime: 0,               // MAX時間有休取得数
      countPaidHolidaysOverHalfTime: 0,     // 法定取得回数
      maxCountPaidHolidaysOverHalfTime: 0,  // MAX法定取得回数
      warningYearPaidLeaveFlg: false,       // 年間有休警告表示フラグ
      warningTimePaidLeaveFlg: false,       // 時間有休警告表示フラグ
      loginUserId: null
    };
  },
  computed: {},

  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    this.getWorkScheduleInfo();
  },

  methods: {
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.WORK_SEGMENT;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    getWorkScheduleInfo: function(){
      let paramList = {
          shainCd: this.loginUserId,
      }
      this.getWithParams(config.URL.HOME_INFO, paramList)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          console.debug("response：" + JSON.stringify(response));
          this.setWorkScheduleInfo(response.container);
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    setWorkScheduleInfo: function(items){
      this.dispDate = this.getStrDateSlash(items.todayInfo.date);
      this.dispDate = items.todayInfo.date;
      this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
      this.dispDateType = items.todayInfo.dateType;
      
      this.shiftStart = items.workAttendanceInfo.shiftStart;
      this.shiftEnd = items.workAttendanceInfo.shiftEnd;
      this.todayWorkInfo = items.workAttendanceInfo.workInfoList;
      this.dailyreportBacklogFlg = items.workAttendanceInfo.dailyreportBacklogFlg;
      this.applicationRequestApprovalFlg = items.workAttendanceInfo.applicationRequestApprovalFlg;
      this.dailyreportConfirmedFlg = items.workAttendanceInfo.dailyreportConfirmedFlg;

      this.workingDays = items.workSummaryInfo.workingDays;
      this.workingTime = items.workSummaryInfo.workingTime;
      this.overtimeHolidayTime = items.workSummaryInfo.overtimeHolidayTime;
      this.disasterTime = items.workSummaryInfo.disasterTime;
      this.paidLeaveDays = items.workSummaryInfo.paidLeaveDays;
      this.paidLeaveTime = items.workSummaryInfo.paidLeaveTime;
      this.absenceDays = items.workSummaryInfo.absenceDays;
      this.absenceTime = items.workSummaryInfo.absenceTime;
      this.lateArrivalEarlyDepartureTime = items.workSummaryInfo.lateArrivalEarlyDepartureTime;
      this.specialVacationDays = items.workSummaryInfo.specialVacationDays;
      this.specialVacationTime = items.workSummaryInfo.specialVacationTime;
      this.remainPaidLeaveDisplayFlg = items.workSummaryInfo.remainPaidLeaveDisplayFlg;
      this.remainPaidLeave = items.workSummaryInfo.remainPaidLeave;
      this.paidLeaveYealyDays = items.workSummaryInfo.paidLeaveYealyDays;
      this.overtimeDisplayFlg = items.workSummaryInfo.overtimeDisplayFlg;
      this.warningOvertimeType = items.workSummaryInfo.warningOvertimeType;
      this.overtimeWorkTime = items.workSummaryInfo.overtimeWorkTime;
      this.overtimeMonthlyMaxHours = items.workSummaryInfo.overtimeMonthlyMaxHours;
      this.overtimeMonthlyMaxTime = items.workSummaryInfo.overtimeMonthlyMaxTime;
      this.warningYealyOvertimeType = items.workSummaryInfo.warningYealyOvertimeType;
      this.yealyOvertimeWorkTime = items.workSummaryInfo.yealyOvertimeWorkTime;
      this.overtimeYealyMaxHours = items.workSummaryInfo.overtimeYealyMaxHours;
      this.overtimeYealyMaxTime = items.workSummaryInfo.overtimeYealyMaxTime;
      this.warningYearPaidLeaveFlg = items.workSummaryInfo.warningYearPaidLeaveFlg;
      this.warningTimePaidLeaveFlg = items.workSummaryInfo.warningTimePaidLeaveFlg;
      this.paidHolidaysTime = items.workSummaryInfo.paidHolidaysTime;
      this.maxPaidHolidaysTime = items.workSummaryInfo.maxPaidHolidaysTime;
      this.countPaidHolidaysOverHalfTime = items.workSummaryInfo.countPaidHolidaysOverHalfTime;
      this.maxCountPaidHolidaysOverHalfTime = items.workSummaryInfo.maxCountPaidHolidaysOverHalfTime;
    },
    clickLinkButton: function (path) {
      this.$router.push(path);
    },
    // 出勤チェック
    isAttendanceCheck: function(workSegment){
      if(workSegment != 1 && workSegment != 11 && workSegment != 12 && workSegment != 21 && workSegment != 22 && workSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 事由 改行コードを<br>にする
    setLineFeedCode: function(msg){
      let newMsg = msg?.replace(/\n/g,'<br>');
      return newMsg;
    }
  },
};
</script>
<style>
/* 日時表示エリア */
.DispDateArea {
  font-size: 1rem;
  font-weight: 400;
  padding: 0.3rem;
  width: 100%;
  text-align: center;
  background: #ececec;
  border-bottom: 1px solid rgb(241, 241, 241);
}

/* 事由表示欄 */
.WorkList_DispMemoArea {
  word-break: break-all;
}

.SummaryItem {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  border-bottom: 1px solid rgb(231, 231, 231);
  padding: 0.2rem;
}
.SummaryItem_Content {
  text-align: right;
}
.text-overtime-warning{
  color: #E83E8C;
}
</style>
